<template>
    <div>
        <error-component
            v-if="exceptions.length > 0 && exceptions[0].message !== 'Private' && exceptions[0].message !== 'Forbidden' && exceptions[0].message !== 'Not a valid word'"
            v-bind="exceptions[0]">
        </error-component>
        <div v-if="fetching">
            <span>fetching...</span>
        </div>
        <div v-else>
            <div v-if="status === 'Forbidden'">
                <span>You can't get access to this report because you are not member of the organization that created it</span>
            </div>
            <div v-if="status === 'Private' || status === 'Not a valid word' && !$auth.check()" class="text-center login-box well white-box login">
                <logo-component></logo-component>
                <error-component
                    v-if="exceptions.length > 0 && exceptions[0].message === 'Not a valid word'"
                    v-bind="exceptions[0]">
                </error-component>
                <div class="secret-form">
                    <div>This is a private report:</div>
                    <div>
                        <router-link :to="{ name: 'login', query: { report_id: this.report_id} }">
                            Log in
                        </router-link>
                        or 
                        <b-button variant="link"
                                  class="pt-0"
                                  @click="secretWord = !secretWord">
                            enter your secret word
                        </b-button>
                    </div>

                    <div v-if="secretWord">
                        <b-form @submit.prevent="submitSecretWord()">
                            <b-form-group>
                                <b-form-input
                                            name="secret word"
                                            v-validate="'required'"
                                            type="password"
                                            v-model="word"
                                            placeholder="Enter your secret word"
                                            :state="errors.has('secret word') ? false: null">
                                </b-form-input>
                                <em v-if="errors.has('secret word')"
                                    class="text-danger">
                                    {{ errors.first('secret word') }}
                                </em>
                            </b-form-group>
                            <b-button type="submit" variant="primary"
                                        :disabled="loading"
                                        class="mr-2">
                                <span>Submit</span>
                                <b-spinner
                                    v-if="loading"
                                    small
                                    class="ml-2" />
                            </b-button>
                        </b-form>
                    </div>
                </div>
            </div>
            <div v-else>
                <render-component :report_id="report_id"></render-component>
                <div v-if="status === 'private' && $auth.check()" style="text-align: center;">
                    <span>You are in visualization mode, go to</span>
                    <router-link :to="{ name: 'report.edit', params: { report_id: this.report_id } }" >
                        <a> Edit</a>
                    </router-link>
                </div>
            </div>
        </div>
    </div>	
</template>

<script>
    import { mapState } from 'vuex'
    import RenderComponent from './Render.vue';
    import ErrorComponent from '../../components/ErrorView.vue';
    import LogoComponent from '../../components/Logo.vue';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        props: ['report_id'],
        components: {
            RenderComponent,
            ErrorComponent,
            LogoComponent
        },
        data() {
            return {
                secretWord: false,
                word: '',
                fetching: true,
                loading: false
            }
        },
        created() {
            let payload = {
                report_id: this.report_id,
                routeQuery: this.$route.query
            };
            this.$store.dispatch('reports/fetchSharedReport', payload).then(() => {
                this.fetching = false;
                if (this.status === 'Private') {
                    $('html').addClass('login');
                }
            });
        },
        computed: {
            ...mapState('reports', {
                status: 'status',
            }),
            ...mapState({
                exceptions: 'exceptions'
            })
        },
        beforeDestroy() {
            this.$store.commit('reports/CLEAR_REPORT_ELEMENTS');
            this.$store.commit('reports/SET_REPORT_STATUS', 'public');
            this.$store.commit('reports/SET_REPORT_ORGANIZATION', '');
            this.$store.commit('CLEAR_EXCEPTIONS');
            this.$store.commit('reports/SET_REPORT_PARAMETERS', []);
            $('html').removeClass('login'); 
        },
        methods: {
            submitSecretWord() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true;
                        let payload = {
                            report_id: this.report_id,
                            routeQuery: this.$route.query,
                            secret_word: this.word
                        };
                        this.$store.dispatch('reports/fetchSharedReport', payload).finally(() => {
                            this.loading = false;
                        })
                    }
                })
            }
        },
    }
</script>

<style scoped>
    .secret-form {
        margin-top: 9px;
    }
    .btn-link {
        color: #007bff;
        vertical-align: baseline;
    }
</style>
